import { render, staticRenderFns } from "./Configuration_Stock.vue?vue&type=template&id=7890a981&"
import script from "./Configuration_Stock.vue?vue&type=script&lang=js&"
export * from "./Configuration_Stock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports